import { useEffect, useState } from "react";
import { SkyButton } from "@skypointcloud/skypoint-ui";
import { X as DismissIcon } from "lucide-react";
import { watchForNewDeployOnFocus } from "../../utils/versionCheck";

/**
 * Non-intrusive "new version available" prompt.
 *
 * A long-lived SPA tab keeps running the bundle it first loaded; after a deploy
 * it can silently run stale code (e.g. a header logo that won't react to a
 * CRM/Advisor toggle) until a full reload. This watches — on tab focus only —
 * for a newer deployed build and offers a one-click refresh. No auto-reload:
 * the user chooses when, so in-progress work is never interrupted.
 */
export function NewVersionBanner() {
  const [available, setAvailable] = useState(false);

  useEffect(() => watchForNewDeployOnFocus(() => setAvailable(true)), []);

  if (!available) return null;

  return (
    <div className="flex items-center justify-center gap-3 border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-sm text-amber-900">
      <span>A new version of skyAdvisor is available.</span>
      <SkyButton
        appearance="primary"
        size="small"
        onClick={() => window.location.reload()}
      >
        Refresh
      </SkyButton>
      <SkyButton
        appearance="transparent"
        size="small"
        icon={DismissIcon}
        aria-label="Dismiss"
        onClick={() => setAvailable(false)}
      />
    </div>
  );
}

export default NewVersionBanner;
